export interface AuthSlide {
  image: string;
  title: string;
  subtitle: string;
}

export const AUTH_SLIDES: AuthSlide[] = [
  {
    image: '/public/images/auth/slide_1.webp',
    title: 'Your backyard is ready.\nAre you?',
    subtitle: 'Hundreds of pre-designed ADU plans, placed on your actual lot — in minutes.',
  },
  {
    image: '/public/images/auth/slide_2.webp',
    title: '700+ plans.\nYour neighborhood.\nYour budget.',
    subtitle:
      'Browse floor plans pre-approved for your region, see what fits your lot, and get a real cost estimate — before talking to anyone.',
  },
  {
    image: '/public/images/auth/slide_3.webp',
    title: 'From idea to contractor quote — step by step.',
    subtitle:
      'Pick a plan → Describe your lot → Receive competing proposals from vetted contractors. No chaos. No guesswork.',
  },
];
